var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.initialRefreshTokenLoading)?_c('RefreshTokenText'):(_vm.isSynchronizingMediaAssets || _vm.isLoadingFonts)?_c('DownloadingMediaAssetLoader'):_c('router-view'),(_vm.showPlayerModal)?_c('PlayerModal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }